import * as React from "react";
import * as THREE from "three";
import type {SidebarValues} from "../../App.tsx";

/**
 * Detects when the object is hovered.
 */
export default class HoverGesture {
    private readonly setIsHovered: React.Dispatch<React.SetStateAction<boolean>>;
    private readonly setValues: SidebarValues;
    private pointers: React.RefObject<Map<number, { x: number; y: number }>>;

    constructor(pointers: React.RefObject<Map<number, { x: number; y: number }>>,
                setIsHovered: React.Dispatch<React.SetStateAction<boolean>>, setValues: SidebarValues) {
        this.setValues = setValues;
        this.pointers = pointers;
        this.setIsHovered = setIsHovered;
    }

    private intersections = (e: THREE.Event & { intersections?: any[] }) => {
        const hasIntersection = (e && e.intersections && e.intersections.length > 0);
        return hasIntersection ? e.intersections!.length : 0;
    }

    syncHovered = (e: THREE.Event & { intersections?: any[] }) => {
        const count = this.intersections(e);
        // console.trace("check hovered " + count);
        const intersects = count > 0;
        this.setIsHovered(intersects);
        document.body.style.cursor = intersects ? 'pointer' : 'default';

        this.setValues((prev) => ({
            ...prev,
            "hovered": intersects.toString(),
            "pointers": this.pointers.current.size
        }));

    }

}


